export const iconValues = {
    'stopwatch': '--icon-stopwatch',
    'angle-left-right': '--icon-angle-left-right',
    'angle-up-down': '--icon-angle-up-down',
    'heart-filled': '--icon-heart-filled',
    'filters-alt-2': '--icon-filters-alt-2',
    'close-bold': '--icon-close-bold',
    'angle-left-bold': '--icon-angle-left-bold',
    'angle-up-bold': '--icon-angle-up-bold',
    'angle-right-bold': '--icon-angle-right-bold',
    'angle-down-bold': '--icon-angle-down-bold',
    close: '--icon-close',
    'three-users': '--icon-three-users',
    'two-users': '--icon-two-users',
    'angle-up': '--icon-angle-up',
    'angle-down': '--icon-angle-down',
    dots: '--icon-dots',
    truck: '--icon-truck',
    eye: '--icon-eye',
    minus: '--icon-minus',
    'shape-round': '--icon-shape-round',
    'shape-emerald': '--icon-shape-emerald',
    'shape-oval': '--icon-shape-oval',
    'shape-cushion': '--icon-shape-cushion',
    'shape-pear': '--icon-shape-pear',
    'shape-princess': '--icon-shape-princess',
    'shape-marquise': '--icon-shape-marquise',
    'shape-hexagonal': '--icon-shape-hexagonal',
    'shape-asscher': '--icon-shape-asscher',
    'shape-radiant': '--icon-shape-radiant',
    'shape-round-alt': '--icon-shape-round-alt',
    'shape-heart': '--icon-shape-heart',
    'shape-european': '--icon-shape-european',
    mta: '--icon-mta',
    underground: '--icon-underground',
    info: '--icon-info',
    accessibility: '--icon-accessibility',
    'clock-alt': '--icon-clock-alt',
    hand: '--icon-hand',
    diamond: '--icon-diamond',
    rings: '--icon-rings',
    'diamond-alt': '--icon-diamond-alt',
    box: '--icon-box',
    'lock-alt': '--icon-lock-alt',
    lock: '--icon-lock',
    'box-return': '--icon-box-return',
    'box-alt': '--icon-box-alt',
    'id-card': '--icon-id-card',
    'credit-card': '--icon-credit-card',
    profile: '--icon-profile',
    'eye-strikethrough': '--icon-eye-strikethrough',
    stop: '--icon-stop',
    play: '--icon-play',
    download: '--icon-download',
    power: '--icon-power',
    key: '--icon-key',
    'dots-vertical': '--icon-dots-vertical',
    globe: '--icon-globe',
    help: '--icon-help',
    thumbsup: '--icon-thumbsup',
    phone: '--icon-phone',
    camera: '--icon-camera',
    'speaker-3': '--icon-speaker-3',
    'speaker-4': '--icon-speaker-4',
    pin: '--icon-pin',
    'chart-alt': '--icon-chart-alt',
    chart: '--icon-chart',
    text: '--icon-text',
    plus: '--icon-plus',
    checkmark: '--icon-checkmark',
    'dots-circle': '--icon-dots-circle',
    'angle-left': '--icon-angle-left',
    'angle-right': '--icon-angle-right',
    'angle-down-circle': '--icon-angle-down-circle',
    'list-circle': '--icon-list-circle',
    'text-circle': '--icon-text-circle',
    'angle-left-circle': '--icon-angle-left-circle',
    'angle-top-circle': '--icon-angle-top-circle',
    'angle-right-circle': '--icon-angle-right-circle',
    'minus-circle': '--icon-minus-circle',
    'plus-circle': '--icon-plus-circle',
    'cross-circle': '--icon-cross-circle',
    clock: '--icon-clock',
    'checkmark-circle': '--icon-checkmark-circle',
    'caution-circle': '--icon-caution-circle',
    'caution-triangle': '--icon-caution-triangle',
    list: '--icon-list',
    hamburger: '--icon-hamburger',
    cart: '--icon-cart',
    bag: '--icon-bag',
    notebook: '--icon-notebook',
    banner: '--icon-banner',
    calendar: '--icon-calendar',
    page: '--icon-page',
    'blank-page': '--icon-blank-page',
    bell: '--icon-bell',
    'filters-alt': '--icon-filters-alt',
    filters: '--icon-filters',
    cog: '--icon-cog',
    'speaker-muted': '--icon-speaker-muted',
    'speaker-1': '--icon-speaker-1',
    'speaker-2': '--icon-speaker-2',
    'pencil-alt-2': '--icon-pencil-alt-2',
    'pencil-alt': '--icon-pencil-alt',
    pencil: '--icon-pencil',
    undo: '--icon-undo',
    refresh: '--icon-refresh',
    redo: '--icon-redo',
    paperclip: '--icon-paperclip',
    envelope: '--icon-envelope',
    'comments-alt': '--icon-comments-alt',
    comments: '--icon-comments',
    'comment-dots-alt': '--icon-comment-dots-alt',
    'comment-dots': '--icon-comment-dots',
    'comment-rows-alt': '--icon-comment-rows-alt',
    'comment-rows': '--icon-comment-rows',
    'comment-empty-alt': '--icon-comment-empty-alt',
    'comment-empty': '--icon-comment-empty',
    link: '--icon-link',
    share: '--icon-share',
    'magnifier-alt': '--icon-magnifier-alt',
    magnifier: '--icon-magnifier',
    house: '--icon-house',
    desktop: '--icon-desktop',
    tablet: '--icon-tablet',
    smartphone: '--icon-smartphone',
    star: '--icon-star',
    heart: '--icon-heart',
    crosshair: '--icon-crosshair',
    map: '--icon-map',
    'paper-airplane': '--icon-paper-airplane',
    'location-pin': '--icon-location-pin',
    facebook: '--icon-facebook',
    pinterest: '--icon-pinterest',
    instagram: '--icon-instagram',
    twitter: '--icon-twitter',
    youtube: '--icon-youtube',
    'three-sixty': '--icon-three-sixty',
}

export type Icons = keyof typeof iconValues

export function isIcon(icon: string): icon is Icons {
    return icon in iconValues
}
